// @flow
import React from 'react'

import styles from './styles'

type HeaderMenuProps = {
  children?: React.ReactNode,
}

const HeaderMenu = (props: HeaderMenuProps) => {
  const { children } = props

  return <div className={styles.headerMenu}>{children}</div>
}

export default HeaderMenu
